/* eslint-disable import/no-unused-modules */
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Flex, Heading } from "@chakra-ui/react";
import { HeartHand } from "~/icons";
import { fontSizes } from "~/utils/theme";
import { useShowReferAFriend } from "./useShowReferAFriend";

interface Props {
  color?: string;
  isInviter?: boolean;
}

export const ReferAFriendHeading: FC<Props> = ({
  color = "th.signatureGreen",
  isInviter,
}) => {
  const { t } = useTranslation();
  const show = useShowReferAFriend();

  if (!isInviter && !show) return null;

  return (
    <Flex gap={2} justify="center">
      <HeartHand color={color} height={6} width={6} />
      <Heading
        as="h2"
        color={color}
        fontSize={fontSizes.x1l}
        textAlign="center"
      >
        {t("inviteAFriend.invitee.heading")}
      </Heading>
    </Flex>
  );
};
